export enum ColorMode {
  EDGEINDEX = 0,
  GROUPS = 1,
  EDGETYPE = 2,
}
